import { Controller } from "stimulus"

export default class extends Controller {

  connect() {
    this.updateContent()
    document.addEventListener('languageChanged', () => this.updateContent())
  }

  updateContent() {
    const lang = document.documentElement.lang

    document.querySelectorAll('[data-content-lang]').forEach(section => {
      if (section.dataset.contentLang === lang) {
        section.classList.remove('hidden')
      } else {
        section.classList.add('hidden')
      }
    })
  }
}